import styled from "@emotion/styled";

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 600px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  overflow-y: auto;
  box-sizing: border-box;
  border-radius: 16px;
  background: var(--alias-color-background-normal-normal);

  cursor: pointer;
`;

export const CancelIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  .title {
    display: flex;
    padding-bottom: 20px;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    border-bottom: 1px solid var(--alias-color-line-normal);
  }

  .guide {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    align-self: stretch;
  }
`;

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  .search {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
  }
`;

export const ChannelItem = styled.div`
  cursor: pointer;
  display: flex;
  padding: 16px;

  align-items: center;
  gap: 12px;
  align-self: stretch;

  border-radius: 10px;
  border: 1px solid var(--alias-color-line-normal);
  background: var(--alias-color-background-normal-normal);
`;

export const ErrorContainer = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  background: var(--global-color-red-95);
`;
